module.exports = __webpack_public_path__ + "img/1726037073378-screenshot-1726037055900.png.fbc3e052.webp";